import { render, staticRenderFns } from "./companyinspectionsetting.html?vue&type=template&id=2871b217&scoped=true&external"
import script from "./companyinspectionsetting.vue?vue&type=script&lang=js"
export * from "./companyinspectionsetting.vue?vue&type=script&lang=js"
import style0 from "./companyinspectionsetting.vue?vue&type=style&index=0&id=2871b217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2871b217",
  null
  
)

export default component.exports